module.exports = __webpack_public_path__ + "static/zound_logo-8cdcc82b2e8b8104894bb37ffa099b99.png";